import * as React from 'react';

import { IOuter } from './TextItemsFilter.types';
import styles from './TextItemsFilter.scss';
import { equals, map, pipe, splitEvery } from 'ramda';
import { mapIndexed } from '../../../utils/array';
import { IFilterItem } from '../../../containers/FilesManager/ExtendedItemsFilters/ExtendedItemsFilters.types';
import { MenuRow } from '../MenuRow';
import { isNewCategory } from '../../../utils/publicMedia';
import { FormattedMessage } from 'react-intl';
import { Badge } from '../index';
import { slug } from 'to-case';

export const TextItemsFilterComponent: React.FC<IOuter> = ({ items, activeItemId, columnsCount, onClick }) => (
  <div className={styles.columns}>
    {pipe(
      splitEvery(columnsCount === -1 ? items.length : Math.ceil(items.length / (columnsCount || 2))),
      mapIndexed((columnItems: IFilterItem[], columnIndex: number) =>
        columnItems.length ? (
          <div key={`column_${columnIndex}`} className={styles.column}>
            {map(
              (item) => (
                <MenuRow
                  key={item.id}
                  text={
                    <>
                      {item.name}
                      {isNewCategory(item) && (
                        <span className={styles.badge}>
                          <Badge size="small" skin="success" type="solid" uppercase>
                            <FormattedMessage id="common.label-new" />
                          </Badge>
                        </span>
                      )}
                    </>
                  }
                  active={equals(activeItemId, item.id)}
                  onClick={onClick(item.id)}
                  dataHook={`filter-item-${slug(item.name)}`}
                />
              ),
              columnItems,
            )}
          </div>
        ) : null,
      ),
    )(items)}
  </div>
);
